var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMypage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.3724 0 0 5.3724 0 12C0 18.6276 5.3724 24 12 24C18.6276 24 24 18.6276 24 12C24 5.3724 18.6276 0 12 0ZM7.8 9C7.8 8.44845 7.90864 7.9023 8.11971 7.39273C8.33078 6.88316 8.64015 6.42016 9.03015 6.03015C9.42016 5.64015 9.88316 5.33078 10.3927 5.11971C10.9023 4.90864 11.4484 4.8 12 4.8C12.5516 4.8 13.0977 4.90864 13.6073 5.11971C14.1168 5.33078 14.5798 5.64015 14.9698 6.03015C15.3599 6.42016 15.6692 6.88316 15.8803 7.39273C16.0914 7.9023 16.2 8.44845 16.2 9C16.2 10.1139 15.7575 11.1822 14.9698 11.9698C14.1822 12.7575 13.1139 13.2 12 13.2C10.8861 13.2 9.81781 12.7575 9.03015 11.9698C8.2425 11.1822 7.8 10.1139 7.8 9ZM19.5096 17.9808C18.611 19.1104 17.469 20.0226 16.1687 20.6492C14.8684 21.2759 13.4434 21.6009 12 21.6C10.5566 21.6009 9.13158 21.2759 7.83128 20.6492C6.53099 20.0226 5.38897 19.1104 4.4904 17.9808C6.4356 16.5852 9.09 15.6 12 15.6C14.91 15.6 17.5644 16.5852 19.5096 17.9808Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.ab064c16243d57c7b9a5da96461ecc4c.svg";
export { ForwardRef as ReactComponent };